<template>
    <div id="app">
        <router-view />
    </div>
</template>
<script>
export default {
    created() {
        if(this.isMobile()){
            this.$router.replace({
                name: 'Mobile'
            })
        }
    },
    methods: {
        isMobile() { //detection PC and Mobile
            if (!!window.navigator.userAgent.match(/AppleWebKit.*Mobile.*/) && !!window.navigator.userAgent.match(/AppleWebKit/)) {
                return true;
            } else {
                return false;
            }
        }
    }
}
</script>
<style lang="scss">
</style>
